import { render, staticRenderFns } from "./IconsAndActionButtons.vue?vue&type=template&id=b1f667b0"
import script from "./IconsAndActionButtons.vue?vue&type=script&lang=js"
export * from "./IconsAndActionButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports